module.exports = __webpack_public_path__ + "img/complete2.60eef9e0.png";